<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading">
                    <svg xmlns="http://www.w3.org/2000/svg" width="39" height="32" viewBox="0 0 39 32" fill="none">
                        <g filter="url(#filter0_d_2093_304)">
                            <path
                                d="M18.408 14.3226C19.7865 14.3282 21.1211 13.8406 22.1683 12.9488C22.3732 12.7748 22.564 12.5849 22.7389 12.3811C22.8953 12.2011 23.0401 12.0115 23.1726 11.8134C23.4517 11.4104 23.678 10.9735 23.8459 10.5134C23.9087 10.3318 23.9657 10.1558 24.0114 9.94577C24.0626 9.7597 24.0989 9.56988 24.1198 9.37809C24.1657 9.09465 24.1886 8.80799 24.1883 8.52089V5.68249C24.1732 4.16824 23.5572 2.72127 22.4745 1.65688C21.3918 0.592487 19.9301 -0.00305794 18.408 1.18086e-05H9.76904C8.23905 1.18086e-05 6.77172 0.604681 5.68986 1.681C4.60799 2.75732 4.00021 4.21711 4.00021 5.73926V8.57766C3.98822 9.97707 4.49624 11.3316 5.42672 12.3811L4.47952 16.2924C4.45666 16.3967 4.46381 16.5053 4.50014 16.6057C4.53648 16.7061 4.60052 16.7943 4.68493 16.8601C4.77837 16.9309 4.89276 16.9688 5.01018 16.968C5.10573 16.9765 5.2019 16.9608 5.28978 16.9226L9.70627 14.3226H18.408ZM14.4138 7.69775V8.48683C14.3809 8.60709 14.3092 8.71325 14.2097 8.78894C14.1102 8.86463 13.9884 8.90564 13.8631 8.90564C13.7379 8.90564 13.6161 8.86463 13.5166 8.78894C13.4171 8.71325 13.3454 8.60709 13.3125 8.48683V7.69775C13.2996 7.31743 13.3705 6.93891 13.5203 6.58879C13.6702 6.23866 13.8953 5.92544 14.1798 5.67114C14.2797 5.54153 14.3528 5.39355 14.3949 5.23571C14.437 5.07788 14.4473 4.91331 14.4252 4.75149C14.4252 4.4835 14.3182 4.22648 14.1277 4.03698C13.9372 3.84748 13.6789 3.74102 13.4095 3.74102C13.1401 3.74102 12.8818 3.84748 12.6913 4.03698C12.5008 4.22648 12.3938 4.4835 12.3938 4.75149C12.4168 4.83569 12.42 4.92402 12.4031 5.00963C12.3862 5.09525 12.3498 5.17584 12.2965 5.24515C12.2432 5.31446 12.1746 5.37063 12.096 5.40928C12.0174 5.44794 11.9309 5.46805 11.8432 5.46805C11.7555 5.46805 11.669 5.44794 11.5904 5.40928C11.5117 5.37063 11.4431 5.31446 11.3899 5.24515C11.3366 5.17584 11.3001 5.09525 11.2833 5.00963C11.2664 4.92402 11.2696 4.83569 11.2926 4.75149C11.2776 4.4661 11.3213 4.18067 11.4208 3.91259C11.5203 3.6445 11.6736 3.39937 11.8714 3.19212C12.0692 2.98486 12.3073 2.81982 12.5712 2.70704C12.8351 2.59426 13.1194 2.5361 13.4067 2.5361C13.6939 2.5361 13.9782 2.59426 14.2421 2.70704C14.506 2.81982 14.7441 2.98486 14.9419 3.19212C15.1397 3.39937 15.293 3.6445 15.3925 3.91259C15.492 4.18067 15.5357 4.4661 15.5207 4.75149C15.551 5.07785 15.5055 5.40676 15.3878 5.71286C15.2701 6.01896 15.0832 6.29407 14.8417 6.51698C14.6844 6.66906 14.5625 6.8536 14.4846 7.05761C14.4068 7.26161 14.3748 7.48012 14.3909 7.69775H14.4138ZM14.4822 10.2126C14.4834 10.3366 14.4474 10.4581 14.3788 10.5616C14.3103 10.6652 14.2123 10.7461 14.0974 10.7941C13.9825 10.842 13.8558 10.8549 13.7335 10.831C13.6113 10.807 13.4989 10.7474 13.4108 10.6598C13.3227 10.5721 13.2628 10.4603 13.2387 10.3387C13.2147 10.217 13.2276 10.091 13.2758 9.97665C13.324 9.86232 13.4054 9.76486 13.5094 9.69668C13.6135 9.62849 13.7357 9.59268 13.8603 9.59381C14.0213 9.59969 14.1736 9.66747 14.2854 9.78288C14.3971 9.89829 14.4595 10.0523 14.4594 10.2126H14.4822Z"
                                fill="#265D91" />
                            <path
                                d="M34.8129 12.3814C34.8069 10.8627 34.1966 9.40811 33.1156 8.33579C32.0345 7.26348 30.5707 6.66067 29.0441 6.65918H25.2781V7.74913H29.0441C30.2791 7.75211 31.4629 8.24075 32.3372 9.1085C33.2116 9.97625 33.7056 11.1527 33.7117 12.3814V15.2198C33.7118 16.4262 33.2389 17.585 32.3936 18.4499C32.328 18.5147 32.2805 18.5953 32.2555 18.6839C32.2305 18.7724 32.2289 18.8658 32.2509 18.9551L32.9699 21.9241L29.5462 19.9202C29.4193 19.8567 29.2766 19.831 29.1354 19.8464H20.4051C19.1979 19.8457 18.0379 19.379 17.1695 18.5447C16.3011 17.7104 15.7918 16.5734 15.749 15.3731H14.6477C14.6908 16.864 15.3161 18.2796 16.391 19.3193C17.466 20.3591 18.9059 20.9411 20.4051 20.942H29.1069L33.5119 23.5079C33.5971 23.5617 33.6964 23.5894 33.7973 23.5874C33.912 23.5882 34.024 23.5524 34.1168 23.4852C34.2022 23.42 34.2674 23.3322 34.3047 23.2317C34.3421 23.1313 34.3501 23.0223 34.3279 22.9175L33.3864 19.0176C34.3077 17.9783 34.8151 16.6396 34.8129 15.2539V12.3814Z"
                                fill="#265D91" />
                            <path
                                d="M31.7774 9.99102C31.7774 9.84046 31.7173 9.69607 31.6103 9.58961C31.5033 9.48315 31.3582 9.42334 31.2068 9.42334H25.2212C25.2212 9.61067 25.1698 9.79233 25.1356 9.99102C25.1013 10.1897 25.0443 10.3543 24.9929 10.5587H31.2239C31.3723 10.5543 31.5131 10.4925 31.6164 10.3865C31.7197 10.2805 31.7775 10.1387 31.7774 9.99102Z"
                                fill="#265D91" />
                            <path
                                d="M23.7034 12.9488H31.6063C31.7576 12.9488 31.9027 12.889 32.0097 12.7826C32.1168 12.6761 32.1769 12.5317 32.1769 12.3812C32.1769 12.2306 32.1168 12.0862 32.0097 11.9797C31.9027 11.8733 31.7576 11.8135 31.6063 11.8135H24.4452C24.3457 12.0088 24.2352 12.1983 24.1142 12.3812C23.9716 12.5742 23.846 12.7558 23.7034 12.9488Z"
                                fill="#265D91" />
                            <path
                                d="M31.6062 14.2207H22.2596C22.1728 14.2277 22.0889 14.2556 22.0153 14.3021C21.9418 14.3486 21.8807 14.4123 21.8374 14.4875C21.7858 14.571 21.76 14.6677 21.7632 14.7657C21.7632 14.9162 21.8233 15.0606 21.9303 15.1671C22.0373 15.2735 22.1825 15.3334 22.3338 15.3334H31.6062C31.727 15.3007 31.8338 15.2293 31.9098 15.1303C31.9859 15.0313 32.0271 14.9102 32.0271 14.7855C32.0271 14.6609 31.9859 14.5398 31.9098 14.4408C31.8338 14.3418 31.727 14.2704 31.6062 14.2377V14.2207Z"
                                fill="#265D91" />
                            <path
                                d="M31.6063 16.6104H18.6307C18.5098 16.643 18.4031 16.7144 18.327 16.8134C18.2509 16.9124 18.2097 17.0335 18.2097 17.1582C18.2097 17.2828 18.2509 17.4039 18.327 17.5029C18.4031 17.6019 18.5098 17.6733 18.6307 17.706H31.6063C31.7271 17.6733 31.8339 17.6019 31.9099 17.5029C31.986 17.4039 32.0272 17.2828 32.0272 17.1582C32.0272 17.0335 31.986 16.9124 31.9099 16.8134C31.8339 16.7144 31.7271 16.643 31.6063 16.6104Z"
                                fill="#265D91" />
                        </g>
                        <defs>
                            <filter id="filter0_d_2093_304" x="0" y="0" width="38.813" height="31.5874"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2093_304" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2093_304"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>
                    FAQ
                </h1>
                <!--begin::Menu-->
            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a routerLink="/accueil" class="text-muted ">Accueil</a>
                  </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
               
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">FAQ</li>

                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content_container" class="app-container container-fluid">
    <div class="card mb-10">
        <div class="card-body tools" [formGroup]="searchFormGroup">
            <div class="title mb-3">
                <h4>Recherche</h4>
            </div>
            <div class="row mb-3">
                <div class="col-lg-3">
                    <input type="text" name="id" id="id" class="form-control form-control-solid mb-3"
                        formControlName="search" placeholder="questions / réponses" (change)="ispagination=false;"  (keyup.enter)="applyFilter(1); startSearching = true">
                </div>
           
                <div class="col-lg-6">
                    <div class="mb-3 search-btn d-flex justify-content-end">
                        <div class="align-items-center recherche">
                            <button type="button" class="me-5" (click)="applyFilter(0); startSearching = true">
                                <svg width="15" height="15" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                        fill="white" />
                                </svg>
                                Rechercher</button>
                        </div>
                        <div class="resett-btn">
                            <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                                title="Réinitialiser">
                                <a (click)="reset()"> <img src="/assets/media/icons/reset.png" alt="" width="30px"></a>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

        </div>

        <!--begin::Card header-->

        <!--end::Card header-->
        <!--begin::Card body-->

        <!--end::Card body-->
    </div>
    <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
        <!--begin::Content container-->
        <div id="kt_app_content_container" class="container-fluid">
            <!--begin::Card-->
        

                 
                        <div class="content">
                            <div class="reviews">
                                <div class="review" *ngFor="let faq of listFaq; let i = index">
                                    <div class="head bg-head">
                                        <div class="number">
                                            <span>{{ offset + i + 1 }}</span>
                                        </div>
                                        <div class="question">
                                            <span>{{ faq.question_FR }}</span>
                                        </div>
                                    </div>
                                    <div class="reply">
                                        <div class="choices  mb-5">
                                           <span> {{ faq.response_f_a_q?.response}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <app-empty-state *ngIf="!listFaq?.length && !loadSpinnerTable"
                            [title]="parentItem"></app-empty-state>

                            <div class="pagination" *ngIf="listFaq?.length">
                                <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                                [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                                aria-label="Select page">
                                </mat-paginator>
                            </div>

                            <div class="spin" *ngIf="!totalItems && loadSpinnerTable">
                                <ngx-spinner class="custom-spinner"
                                bdColor="rgba(255,255,255,1)"
                                  size="medium"
                                  color="#fff"
                                  type="ball-atom"
                                  [fullScreen]="true"
                                >
                                <span class="loader">
                                    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
                                </span>
                                </ngx-spinner>
                            </div>
                        </div>
                  
             
            <!--end::Card-->
        </div>
        <!--end::Content container-->
    </div>
</div>
